import React from 'react';

const PageSpinner: React.FC = () => {
  return (
    <div className="page-spinner">
      <p>Loading...</p>
    </div>
  );
};

export default PageSpinner;
